import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import cx from 'classnames';
import i18n from 'i18next';
import { withTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import $ from 'jquery';
import moment from 'moment';
import { TablePagination } from '@material-ui/core';
import { CloudOffOutlined, Assignment, CloudUpload } from '@material-ui/icons';
import PopupDialog from 'ui/components/popup-dialog';
import Tabs from './ui/react-ui/tabs';
import DataTable from './ui/table';
import SearchBar from './ui/searchBar';
import Progress from './ui/react-ui/progress.jsx';
import LiveMessageDraftEdit from './liveMessage/liveMessageDraft-edit';
import LiveMessageTypeEdit from './liveMessage/liveMessageType-edit';
import LiveMessageDetialDialog from './liveMessage/liveMessageDetial-dialog';
import { getMessageEventTypeList, getMessageEventList, getMessageEventListPublished, editMessageAPI, deleteMessageAPI, editMessagePublishStatusAPI } from '../api/messageAPI'; // redux

import { setMessageTypeList, setDialogInfo, clearDialogInfo, setNewMessageSort, setMessageDraftSort, setPublishedSort, setNewMessageData, setMessageDraftData, setMessagePublishedData } from '../redux/live-message';
var t = i18n.getFixedT(null, 'live-message');
var gt = i18n.getFixedT(null, 'app');
var LiveMessage = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      _useSelector$liveMess = _useSelector.liveMessage,
      messageTypeList = _useSelector$liveMess.messageTypeList,
      newMessageSort = _useSelector$liveMess.newMessageSort,
      messageDraftSort = _useSelector$liveMess.messageDraftSort,
      publishedSort = _useSelector$liveMess.publishedSort,
      newMessageData = _useSelector$liveMess.newMessageData,
      messageDraftData = _useSelector$liveMess.messageDraftData,
      messagePublishedData = _useSelector$liveMess.messagePublishedData;

  var dispatch = useDispatch();
  var id = props.id;

  var _useState = useState('newMessage'),
      _useState2 = _slicedToArray(_useState, 2),
      currentTab = _useState2[0],
      setCurrentTab = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      currentPage = _useState4[0],
      setCurrentPage = _useState4[1];

  var _useState5 = useState(19),
      _useState6 = _slicedToArray(_useState5, 2),
      totalCount = _useState6[0],
      setTotalCount = _useState6[1];

  var _useState7 = useState(10),
      _useState8 = _slicedToArray(_useState7, 2),
      rowsPerPage = _useState8[0],
      setRowsPerPage = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      selectedItems = _useState10[0],
      setSelectedItems = _useState10[1];

  var _useState11 = useState(''),
      _useState12 = _slicedToArray(_useState11, 2),
      keyword = _useState12[0],
      setKeyword = _useState12[1];

  var _useState13 = useState(),
      _useState14 = _slicedToArray(_useState13, 2),
      detialData = _useState14[0],
      setDetialData = _useState14[1];

  var _isMounted = useRef(false);

  var _isResetUseState = useRef(false);

  var _currentData = useRef([]);

  var tabsMenu = [{
    key: 'newMessage',
    title: t('lbl-new-message')
  }, {
    key: 'messageDraft',
    title: t('lbl-message-draft')
  }, {
    key: 'published',
    title: t('lbl-published')
  }];

  var handleChangePage = function handleChangePage(e, newPage) {
    setCurrentPage(newPage);
  };

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(e) {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
  };

  var handleSort = function handleSort(sort) {
    switch (currentTab) {
      case 'newMessage':
        dispatch(setNewMessageSort(sort));

      case 'messageDraft':
        dispatch(setMessageDraftSort(sort));

      case 'published':
        dispatch(setPublishedSort(sort));
    }
  };

  var handleCloseDialog = function handleCloseDialog() {
    dispatch(clearDialogInfo());
    fetchData();
    setSelectedItems([]);
  };

  var handleOpenDialog = function handleOpenDialog(type) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    if (type === 'messageType.edit') {
      var messageTypeData = _.map(_.cloneDeep(messageTypeList), function (el) {
        el.autoUnpublish = el.autoUnpublishAfterStart > -1;
        return el;
      });

      return dispatch(setDialogInfo({
        mode: type,
        data: messageTypeData
      }));
    }

    dispatch(setDialogInfo({
      mode: type,
      data: type.indexOf('edit') > -1 ? data : {}
    }));
  };

  var handleMessagePublish = function handleMessagePublish(itemAry, isPublish) {
    return new Promise(function (resolve, reject) {
      var callAPI = function callAPI(data) {
        editMessagePublishStatusAPI(contextRoot, true, data, isPublish).then(function (result) {
          itemAry.shift();
          if (itemAry.length === 0) return resolve('ok');
          callAPI(itemAry[0]);
        });
      };

      callAPI(itemAry[0]);
    });
  };

  var handleUnpublished = function handleUnpublished(singleItem) {
    var unpublishedData = [];
    if (singleItem) unpublishedData.push(singleItem);else unpublishedData = _.filter(_.cloneDeep(_currentData.current), function (el) {
      return _.some(selectedItems, function (id) {
        return id === el.id;
      });
    });
    PopupDialog.confirm({
      title: t("dlg-unpublished-message"),
      display: t("txt-unpublished-message"),
      cancelText: gt('global.lbl-answer-cancel'),
      confirmText: gt('global.lbl-answer-ok'),
      act: function act(confirmed) {
        if (confirmed) {
          Progress.startSpin();
          handleMessagePublish(unpublishedData, false).then(function (result) {
            Progress.done();
            fetchData();
            setSelectedItems([]);
          });
        }
      }
    });
  };

  var handlePublished = function handlePublished(singleItem) {
    var publishData = [];

    if (singleItem) {
      var data = _.cloneDeep(singleItem);

      _.set(data, 'isPublished', true);

      publishData.push(data);
    } else {
      publishData = _.filter(_.cloneDeep(_currentData.current), function (el) {
        return _.some(selectedItems, function (id) {
          return id === el.id;
        });
      });

      _.forEach(publishData, function (el) {
        return el.isPublished = true;
      });
    }

    PopupDialog.confirm({
      title: t("dlg-published-message"),
      display: t("txt-published-message"),
      cancelText: gt('global.lbl-answer-cancel'),
      confirmText: gt('global.lbl-answer-ok'),
      act: function act(confirmed) {
        if (confirmed) {
          Progress.startSpin();
          handleMessagePublish(publishData, true).then(function (result) {
            Progress.done();
            fetchData();
            setSelectedItems([]);
          });
        }
      }
    });
  };

  var handleDelete = function handleDelete(messageData) {
    PopupDialog.confirm({
      title: t('dlg-delete-message'),
      display: t('txt-deleted-message'),
      cancelText: gt('global.lbl-answer-cancel'),
      confirmText: gt('global.lbl-answer-ok'),
      act: function act(confirmed) {
        if (confirmed) {
          deleteMessageAPI(contextRoot, false, messageData).then(function (result) {
            fetchData();
          });
        }
      }
    });
  };

  var handleOpenDetailDialog = function handleOpenDetailDialog(data) {
    setDetialData(data);
  };

  var closeDetialDialog = function closeDetialDialog() {
    setDetialData(null);
  };

  var fetchData = function fetchData() {
    var isInit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var _currentPage, _rowsPerPage, _keyword;

    _currentPage = isInit ? 0 : currentPage;
    _rowsPerPage = isInit ? 10 : rowsPerPage;
    _keyword = isInit ? '' : keyword;
    var offset = (Number(_currentPage + 1) - 1) * rowsPerPage;

    switch (currentTab) {
      case 'newMessage':
        getMessageEventList(contextRoot, false, _keyword, newMessageSort, offset, _rowsPerPage, true).then(function (result) {
          var messageListExternal = _.map(result.content, function (el, index) {
            return _objectSpread(_objectSpread({}, el), {}, {
              sequence: offset + index + 1
            });
          });

          dispatch(setNewMessageData(messageListExternal));
          setTotalCount(result.totalElements);
        });
        break;

      case 'messageDraft':
        getMessageEventList(contextRoot, false, _keyword, messageDraftSort, offset, _rowsPerPage, false).then(function (result) {
          var messageListInternal = _.map(result.content, function (el, index) {
            return _objectSpread(_objectSpread({}, el), {}, {
              sequence: offset + index + 1
            });
          });

          dispatch(setMessageDraftData(messageListInternal));
          setTotalCount(result.totalElements);
        });
        break;

      case 'published':
        getMessageEventListPublished(contextRoot, false, _keyword, publishedSort, offset, _rowsPerPage).then(function (result) {
          var messageListPublished = _.map(result.content, function (el, index) {
            return _objectSpread(_objectSpread({}, el), {}, {
              sequence: offset + index + 1
            });
          });

          dispatch(setMessagePublishedData(messageListPublished));
          setTotalCount(result.totalElements);
        });
        break;
    }
  };

  useEffect(function () {
    if (!_isMounted.current) return;
    if (!_isResetUseState.current) fetchData();
    _isResetUseState.current = false;
  }, [JSON.stringify(newMessageSort), JSON.stringify(messageDraftSort), JSON.stringify(publishedSort), currentPage, rowsPerPage]);
  useEffect(function () {
    if (!_isMounted.current) return;
    if (currentPage !== 0) return setCurrentPage(0);
    if (!_isResetUseState.current) fetchData();
    _isResetUseState.current = false;
  }, [keyword]);
  useEffect(function () {
    if (!_isMounted.current) return;
    if (keyword !== '' || currentPage !== 0 || rowsPerPage !== 10 || selectedItems.length > 0) _isResetUseState.current = true;
    setCurrentPage(0);
    setRowsPerPage(10);
    setKeyword('');
    setSelectedItems([]);
    _currentData.current = [];
    fetchData(true);
  }, [currentTab]);
  useEffect(function () {
    if (!_isMounted.current) {
      var messageEventTypeList = getMessageEventTypeList(contextRoot, true);
      var messageListExternal = getMessageEventList(contextRoot, true, '', newMessageSort, 0, 10, true);
      Progress.startSpin();
      $.when(messageEventTypeList, messageListExternal).then(function (result_messageType, result_messageExternal) {
        dispatch(setMessageTypeList(result_messageType.content));

        var messageList = _.map(result_messageExternal.content, function (el, index) {
          return _objectSpread(_objectSpread({}, el), {}, {
            sequence: index + 1
          });
        });

        dispatch(setNewMessageData(messageList));
        setTotalCount(result_messageExternal.totalElements);
        _isMounted.current = true;
        Progress.done();
      });
    }
  }, []);
  var fields = {},
      sort = null;

  _.set(fields, 'sequence', {
    label: t('lbl-sequence')
  });

  _.set(fields, 'type', {
    label: t('lbl-message-type')
  });

  _.set(fields, 'title', {
    label: t('lbl-message-title'),
    sortable: true
  });

  _.set(fields, 'description', {
    label: t('lbl-message-description'),
    sortable: true,
    formatter: function formatter(val, row) {
      if (_.isEmpty(val)) return null;

      var textAry = _.split(val, /\r?\n/g);

      return textAry.length > 1 ? textAry[0] + '...' : val;
    }
  });

  if (currentTab === 'newMessage') {
    _currentData.current = newMessageData;
    sort = newMessageSort;

    _.set(fields, 'createdAt', {
      label: t('lbl-received-time'),
      sortable: true
    });

    _.set(fields, 'source', {
      label: t('lbl-info-source'),
      sortable: true
    });

    _.set(fields, 'beginTime', {
      label: t('lbl-start-time'),
      sortable: true
    });

    _.set(fields, 'endTime', {
      label: t('lbl-end-time'),
      sortable: true
    });

    _.set(fields, 'more', {
      label: t('lbl-more'),
      formatter: function formatter(val, row) {
        return /*#__PURE__*/React.createElement("div", {
          className: "icon-block"
        }, /*#__PURE__*/React.createElement("a", {
          title: t('lbl-publish'),
          onClick: function onClick() {
            return handlePublished(row);
          }
        }, /*#__PURE__*/React.createElement("i", {
          class: "fab fa-telegram-plane"
        })), /*#__PURE__*/React.createElement("a", {
          title: t('lbl-edit'),
          onClick: function onClick() {
            return handleOpenDialog('messageDraft.edit', row);
          }
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-pencil-alt fa-list-alt"
        })), /*#__PURE__*/React.createElement("a", {
          title: t('lbl-deleted'),
          className: "delete",
          onClick: function onClick() {
            return handleDelete(row);
          }
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-trash"
        })));
      }
    });
  } else if (currentTab === 'messageDraft') {
    _currentData.current = messageDraftData;
    sort = messageDraftSort;

    _.set(fields, 'createdAt', {
      label: t('lbl-created-time'),
      sortable: true
    }); // _.set(fields, 'editor', { label: t('lbl-editor'), sortable:true })


    _.set(fields, 'beginTime', {
      label: t('lbl-start-time'),
      sortable: true
    });

    _.set(fields, 'endTime', {
      label: t('lbl-end-time'),
      sortable: true
    });

    _.set(fields, 'more', {
      label: t('lbl-more'),
      formatter: function formatter(val, row) {
        return /*#__PURE__*/React.createElement("div", {
          className: "icon-block"
        }, /*#__PURE__*/React.createElement("a", {
          title: t('lbl-publish'),
          onClick: function onClick() {
            return handlePublished(row);
          }
        }, /*#__PURE__*/React.createElement("i", {
          class: "fab fa-telegram-plane"
        })), /*#__PURE__*/React.createElement("a", {
          title: t('lbl-edit'),
          onClick: function onClick() {
            return handleOpenDialog('messageDraft.edit', row);
          }
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-pencil-alt fa-list-alt"
        })), /*#__PURE__*/React.createElement("a", {
          title: t('lbl-deleted'),
          className: "delete",
          onClick: function onClick() {
            return handleDelete(row);
          }
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-trash"
        })));
      }
    });
  } else {
    _currentData.current = messagePublishedData;
    sort = publishedSort;

    _.set(fields, 'createdAt', {
      label: t('lbl-created-received-time'),
      sortable: true
    });

    _.set(fields, 'source', {
      label: t('lbl-info-source'),
      sortable: true
    }); // _.set(fields, 'editor', { label: t('lbl-editor'), sortable:true })


    _.set(fields, 'beginTime', {
      label: t('lbl-start-time'),
      sortable: true
    });

    _.set(fields, 'endTime', {
      label: t('lbl-end-time'),
      sortable: true
    }); // _.set(fields, 'status', { label: t('lbl-status'), sortable:true })


    _.set(fields, 'more', {
      label: t('lbl-more'),
      formatter: function formatter(val, row) {
        var now = moment().valueOf();
        var endTime = moment(row.endTime).valueOf();
        var delistOrPublishDom = /*#__PURE__*/React.createElement("a", {
          title: t('lbl-delist'),
          className: "delete",
          onClick: function onClick() {
            return handleUnpublished(row);
          }
        }, /*#__PURE__*/React.createElement(CloudOffOutlined, null));

        if (endTime < now) {
          delistOrPublishDom = /*#__PURE__*/React.createElement("a", {
            title: t('lbl-re-publish'),
            onClick: function onClick() {
              return handlePublished(row);
            }
          }, /*#__PURE__*/React.createElement(CloudUpload, null));
        }

        return /*#__PURE__*/React.createElement("div", {
          className: "icon-block"
        }, delistOrPublishDom, /*#__PURE__*/React.createElement("a", {
          title: t('lbl-detial'),
          onClick: function onClick() {
            return handleOpenDetailDialog(row);
          }
        }, /*#__PURE__*/React.createElement(Assignment, null)));
      }
    });
  }

  return /*#__PURE__*/React.createElement("div", {
    id: id
  }, /*#__PURE__*/React.createElement("div", {
    className: "live-message-headBar"
  }, /*#__PURE__*/React.createElement(SearchBar, {
    searchIconPosition: "right",
    placeholder: "Search",
    onSearch: function onSearch(searchText) {
      if (_.isEmpty(keyword) && _.isEmpty(searchText) && currentPage !== 0) return setCurrentPage(0);
      if (_.isEmpty(keyword)) fetchData();
      setKeyword(searchText);
    },
    value: keyword
  }), /*#__PURE__*/React.createElement("a", {
    className: "icon",
    onClick: function onClick() {
      return handleOpenDialog('messageType.edit');
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-cog"
  })), currentTab === 'messageDraft' && /*#__PURE__*/React.createElement("a", {
    className: "icon",
    onClick: function onClick() {
      return handleOpenDialog('messageDraft.create');
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-plus"
  }))), /*#__PURE__*/React.createElement(Tabs, {
    id: "g-live-message-tabs",
    menu: tabsMenu,
    current: currentTab,
    onChange: function onChange(key) {
      return setCurrentTab(key);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt"
  }, /*#__PURE__*/React.createElement(DataTable, {
    fields: fields,
    data: _currentData.current,
    rowIdField: "id",
    selectable: {
      toggleAll: true
    },
    selected: selectedItems,
    onSelectionChange: function onSelectionChange(val) {
      return setSelectedItems(val);
    },
    sort: sort,
    onSort: handleSort
  })), /*#__PURE__*/React.createElement(TablePagination, {
    component: "div",
    labelRowsPerPage: t('lbl-per-page-row-count'),
    count: totalCount,
    page: currentPage,
    onChangePage: handleChangePage,
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  }), /*#__PURE__*/React.createElement("div", {
    className: "footer"
  }, currentTab === 'published' && /*#__PURE__*/React.createElement("button", {
    style: {
      marginLeft: '15px'
    },
    className: cx('button'),
    onClick: function onClick() {
      handlePublished();
    },
    disabled: selectedItems.length > 0 ? false : true
  }, t('lbl-publish')), /*#__PURE__*/React.createElement("button", {
    className: cx('button', {
      'delete': currentTab === 'published'
    }),
    onClick: function onClick() {
      if (currentTab === 'published') handleUnpublished();else handlePublished();
    },
    disabled: selectedItems.length > 0 ? false : true
  }, currentTab === 'published' ? t('lbl-delist') : t('lbl-publish')))), /*#__PURE__*/React.createElement(LiveMessageTypeEdit, null), /*#__PURE__*/React.createElement(LiveMessageDraftEdit, {
    onClose: handleCloseDialog
  }), !_.isEmpty(detialData) && /*#__PURE__*/React.createElement(LiveMessageDetialDialog, {
    data: detialData,
    onClose: closeDetialDialog
  }));
});
LiveMessage.defaultProps = {
  id: 'g-live-message'
};
LiveMessage.PropTypes = {
  id: PropTypes.string
};
export default withTranslation(['live-message'])(LiveMessage);